import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import { Box, DraggableGrid } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './MetricsCardStrip.module.scss';
export const GetMetricsCardStripTID = (parentTestId)=>getTestIds(parentTestId);
const ItemRenderer = (param)=>{
    let { render, isDragActive, dragHandle, onRemove } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: render({
            isEditMode: true,
            isDragActive,
            dragHandle,
            onRemove
        })
    });
};
export const MetricsCardStrip = (param)=>{
    let { items, isEditMode, onReorder, onRemove, testId } = param;
    const { MetricsCardStripTestIds } = useMemo(()=>GetMetricsCardStripTID(testId), [
        testId
    ]);
    const rootRef = useRef(null);
    const previousItemCountRef = useRef(items.length);
    useEffect(()=>{
        const previousCount = previousItemCountRef.current;
        previousItemCountRef.current = items.length;
        if (items.length > previousCount && rootRef.current != null) {
            rootRef.current.scrollTo({
                left: rootRef.current.scrollWidth,
                behavior: 'smooth'
            });
        }
    }, [
        items.length
    ]);
    if (isEditMode) {
        const draggableItems = items.map((item)=>_object_spread_props(_object_spread({}, item), {
                onRemove: onRemove ? ()=>onRemove(item.id) : undefined
            }));
        return /*#__PURE__*/ _jsx("div", {
            ref: rootRef,
            className: styles.root,
            "data-testid": MetricsCardStripTestIds.Root(),
            children: /*#__PURE__*/ _jsx(DraggableGrid, {
                bi: {
                    name: 'reorder_invoice_metric_card'
                },
                className: styles.draggableGridOverride,
                itemClassName: styles.draggableGridItem,
                items: draggableItems,
                itemComponent: ItemRenderer,
                layout: {
                    rows: 1
                },
                gap: 16,
                dragMode: "withGhost",
                itemHandleVisibility: "always",
                itemDragActivation: "handle",
                itemHandlePosition: "inside",
                onReorder: (reordered)=>onReorder === null || onReorder === void 0 ? void 0 : onReorder(reordered.map((item)=>item.id))
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        ref: rootRef,
        className: styles.root,
        "data-testid": MetricsCardStripTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Box, {
            className: styles.staticStrip,
            children: items.map((item)=>/*#__PURE__*/ _jsx(Box, {
                    className: styles.staticItem,
                    testId: MetricsCardStripTestIds.Item(item.id),
                    children: item.render({
                        isEditMode: false
                    })
                }, item.id))
        })
    });
};
